import type { ConferenceDisplayNames } from "./portfolio-overview-api";

export function localizedConferenceName(
  conference: {
    readonly name: string;
    readonly displayNames?: ConferenceDisplayNames | null;
  },
  locale: string,
): string {
  return (
    (locale.startsWith("ar")
      ? conference.displayNames?.ar
      : conference.displayNames?.en
    )?.trim() || conference.name
  );
}
